"use client"
import PropTypes from "prop-types"

const Button = ({ children, type = "button", onClick, disabled = false, className = "" }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 bg-amber-600 text-white rounded-lg font-medium shadow-sm transition-all duration-200 
      hover:bg-amber-700 hover:shadow-md active:scale-98 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 
      ${disabled ? "opacity-50 cursor-not-allowed hover:bg-amber-600 hover:shadow-sm active:scale-100" : ""} ${className}`}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default Button
